import config from "@/config"
import http from "@/utils/request"

export default {
    getSummaryPageList: {
        url: `${config.API_URL}/api/app/df-statistics/summary-page-list`,
        name: "获取分页数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getAsinSummaryPageList: {
        url: `${config.API_URL}/api/app/df-statistics/asin-summary-page-list`,
        name: "根据Asin类型分数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getFatherAsinSummaryPageList: {
        url: `${config.API_URL}/api/app/df-statistics/father-asin-summary-page-list`,
        name: "根据父Asin类型分数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    exportAsinSummaryList: {
        url: `${config.API_URL}/api/app/df-statistics/export-asin-summary-list`,
        name: "导出Asin数据",
        post: async function (params) {
            return await http.post(this.url, params, {
                responseType: 'blob'
            });
        }
    },
    exportFatherAsinSummaryList: {
        url: `${config.API_URL}/api/app/df-statistics/export-father-asin-summary-list`,
        name: "导出父Asin数据",
        post: async function (params) {
            return await http.post(this.url, params, {
                responseType: 'blob'
            });
        }
    },
    getLocalSkuSummaryPageList: {
        url: `${config.API_URL}/api/app/df-statistics/local-sku-summary-page-list`,
        name: "根据LocalSku类型分数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getShopSummaryPageList: {
        url: `${config.API_URL}/api/app/df-statistics/shop-summary-page-list`,
        name: "根据店铺类型分数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

    //VC销量统计
    getAsinVcSalesSummaryPageList: {
        url: `${config.API_URL}/api/app/vc-sales-statistics/asin-page-list`,
        name: "VC销量统计Asin",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getFatherAsinVcSalesSummaryPageList: {
        url: `${config.API_URL}/api/app/vc-sales-statistics/father-asin-page-list`,
        name: "VC销量统计父Asin",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    //Asin销量统计导出
    exportAsinVcSalesList: {
        url: `${config.API_URL}/api/app/vc-sales-statistics/export-asin-list`,
        name: "VC销量统计Asin导出",
        post: async function (params) {
            return await http.post(this.url, params, {
                responseType: 'blob'
            });
        }
    },
    getLocalSkuVcSalesSummaryPageList: {
        url: `${config.API_URL}/api/app/vc-sales-statistics/local-sku-page-list`,
        name: "VC销量统计LocalSku",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getShopVcSalesSummaryPageList: {
        url: `${config.API_URL}/api/app/vc-sales-statistics/shop-page-list`,
        name: "VC销量统计Shop",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },



    //VC库存统计
    getVcInventoryStatisticsPageList: {
        url: `${config.API_URL}/api/app/vc-inventory-statistics/page-list`,
        name: "VC库存统计",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

    //首页统计
    home: {
        //获取首页销售统计
        getHomeSaleStatistics: {
            url: `${config.API_URL}/api/app/vc-sales-statistics/home-sale`,
            name: "首页销售统计",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getDfOrderHomes: {
            url: `${config.API_URL}/api/app/df-statistics/df-order-home`,
            name: "首页DF订单统计",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    }
}